import { Link } from "react-router";
import { useEffect } from "react";
import Diamond from "../components/symbols/Diamond";
import routes from "../routes";

import './Routes.css';

function normalizePath(path = '/') {
  if (!path) return '/';
  const withLeadingSlash = path[0] === '/' ? path : `/${path}`;
  return withLeadingSlash.replace(/\/{2,}/g, '/');
}

function buildRoutePath(parentPath = '', childPath = '') {
  if (!childPath) return normalizePath(parentPath || '/');
  if (childPath[0] === '/') return normalizePath(childPath);
  if (!parentPath || parentPath === '/') return normalizePath(`/${childPath}`);
  return normalizePath(`${parentPath}/${childPath}`);
}

function Route({
  path,
  index,
  children,
  parentPath = '',
}) {
  const link = index ? normalizePath(parentPath || '/') : buildRoutePath(parentPath, path);

  return (
    <div key={path}>
      <Link to={link}>
        {link}
      </Link>

      {children ? (
        <div style={{
          marginLeft: '0.5rem',
          paddingLeft: '0.5rem',
          borderLeft: '1px solid'
        }}>
          {children.map((r, i) => (
            <Route
              {...r}
              key={`${link}::${r.path ?? 'index'}::${i}`}
              parentPath={link}
            />
          ))}
        </div>
      ) : null}

    </div>
  );
}

function Routes() {
  useEffect(() => {
    document.title = '__routes';
  }, []);

  return <div
    className="Routes"
  >
    <div
      className="Routes__list"
    >
      {routes.map((r, i) => (
        <Route
          {...r}
          key={`${r.path ?? 'index'}::${i}`}
          parentPath=""
        />
      ))}

      <Diamond />
    </div>
  </div>
}

export default Routes;
